import { createFileRoute, Outlet } from "@tanstack/react-router"

import { RouteErrorBoundary } from "@/components/shared/route-error-boundary"

export const Route = createFileRoute("/_authed/_admin/guild-events")({
  component: GuildEventsLayout,
  errorComponent: RouteErrorBoundary,
})

function GuildEventsLayout() {
  return <Outlet />
}
